import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  getThongKeDonTaiDonVi: {
    url: `${API_URL}/thongKes/thongKeDonTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonXuLyTaiDonVi: {
    url: `${API_URL}/thongKes/thongKeDonXuLyGiaiQuyetTaiDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuTrangThaiXLGQDons: {
    url: `${API_URL}/lichSuTrangThaiXuLyGiaiQuyetDonCongDans`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuTrangThaiXLGQDonTaiDonVis: {
    url: `${API_URL}/lichSuTrangThaiXuLyGiaiQuyetDonTaiDonVis`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getlichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs: {
    url: `${API_URL}/lichSuTrangThaiXuLyGiaiQuyetDonToanHeThongs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonTaiDiaBan: {
    url: `${API_URL}/thongKes/thongKeDonTaiDiaBan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonCuaNam: {
    url: `${API_URL}/thongKes/thongKeBieuDoDonCuaNam`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonTheoPhanLoai: {
    url: `${API_URL}/thongKes/thongKeBieuDoDonTheoPhanLoai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeBieuDoDonTheoLinhVuc: {
    url: `${API_URL}/thongKes/thongKeBieuDoDonTheoLinhVuc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonTreHan: {
    url: `${API_URL}/thongKes/thongKeDonTreHan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeDonMoiNhat: {
    url: `${API_URL}/thongKes/thongKeDonMoiNhat`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonCongDan: {
    url: `${API_URL}/traCuuDons/congDan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonCanBo: {
    url: `${API_URL}/traCuuDons/canBo`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTraCuuDonTTCP: {
    url: `${API_URL}/donTTCPs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTinhTrangTraCuuDon: {
    url: `${API_URL}/tinhTrangXuLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongBao: {
    url: `${API_URL}/thongBaos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getUnreadNotify: {
    url: `${API_URL}/thongBaos/soLuongChuaXem`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  updateNotify: {
    url: `${API_URL}/thongBaos/:id`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getChiTietThongBao: {
    url: `${API_URL}/thongBao/:id`,
    options: (url, params, getState) => {
      return {
        method: 'GET',
        params: params
      };
    }
  },
  getCountKeHoachThanhTra: {
    url: `${API_URL}/thongKes/countKeHoachThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountDanhMucCuocThanhTra: {
    url: `${API_URL}/thongKes/countDanhMucCuocThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountTheoDoiCuocThanhTra: {
    url: `${API_URL}/thongKes/countTheoDoiCuocThanhTra`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCountTheoDoiCuocThanhTraTheoNam: {
    url: `${API_URL}/thongKes/countCuocThanhTraTheoNam`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCheckLuaChonDonVi: {
    url: `${API_URL}/thongKes/luaChonDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/trangChu.js